import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { AddBankAccountForm } from '@/features/cleaner/add-bank-account-form';
import { HeaderDashboard } from '@/components/shared/header-dashboard';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/payout-add-bank-account'
)({
  component: AddBankAccountPage,
});

function AddBankAccountPage() {
  const navigate = useNavigate();
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.BackButton
          onClick={() => navigate({ to: '/cleaner/payout' })}
        />
        <HeaderDashboard.Title>Add Bank Account</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <AddBankAccountForm />
      </div>
    </div>
  );
}
